module.exports = __webpack_public_path__ + "img/特大暴雨.784e9ce3.png";